import React, { createContext, ReactElement } from 'react';

import FormFieldLabel from './FormFieldLabel';
import { IFormOptionValueProps } from './FormOptionValue';
import { IFormFieldProps } from './models';
import { useFormField } from './useFormField';

interface IFormOptionsFieldContext {
  name: string;
  type: 'radio' | 'checkbox';
}

export const FormOptionsFieldContext = createContext<IFormOptionsFieldContext>(null);

interface IProps extends IFormFieldProps {
  children: ReactElement<IFormOptionValueProps>[];
  type?: 'radio' | 'checkbox';
}

function FormOptionsField({ name, label, optional, size, children, type = 'radio' }: IProps) {
  const { fieldProps } = useFormField(name, size);

  return (
    <FormOptionsFieldContext.Provider value={{ name, type }}>
      <div {...fieldProps}>
        {label && <FormFieldLabel optional={optional}>{label}</FormFieldLabel>}
        <div className="modFormField__options" role="group">
          {children}
        </div>
      </div>
    </FormOptionsFieldContext.Provider>
  );
}

export default FormOptionsField;
